const rata = { t: 'Rata', type: 'range', name: 'rata', unit: 'zł', hint: { url: '/installment' }}
export default rata